import * as React from "react"
import {Link} from "gatsby";
import T from "../T/T";
import "./styles.scss";
import {LocaleLink} from "../../lib/IntlTools";
import {useState} from "react";

export default function ClaimReward({showReward}) {
    const [isVisible, setVisible] = useState(!showReward);

    // Define functions
    const close = () => {
        setVisible(false);
    }

    return isVisible ? (
        <div className="sticky-footer">
            <div className="sticky-footer-body">
                <button className="icon-close" onClick={close} aria-label="Close">
                    x
                </button>

                <p>
                    <T>popup-claim-message</T>
                </p>

                <Link to={LocaleLink("/form/")}
                      className="uk-button uk-width-1-1 uk-button-secondary uk-margin hideClaim">
                    <T>popup-claim-button</T>
                </Link>
            </div>
        </div>
    ) : null
}
